import TextHighlighter from 'components/text/TextHighlighter';
import { Props as ReactSelectProps } from 'react-select';

type Option = {
  label: string;
  value: string;
};

type FormatOptionLabel<T extends Option = Option> =
  ReactSelectProps<T>['formatOptionLabel'];

export function formatOptionLabelWithHighlight<T extends Option = Option>(
  // @ts-expect-error TS2344 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  ...args: Parameters<FormatOptionLabel<T>>
) {
  const [{ label }, { inputValue }] = args;

  return <TextHighlighter text={label} textToHighlight={inputValue} />;
}
